var _defs, _ellipse, _path, _path2, _path3, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFiat(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "fiat",
    width: 49.972,
    height: 49.971,
    viewBox: "0 0 49.972 49.971",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#ccc}.cls-2{fill:#a6a6a6}.cls-3{fill:#e3e3e3}.cls-4{fill:#e82934}.cls-5{fill:#f5f5f5}\n        "))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_7",
    cx: 24.986,
    cy: 24.986,
    className: "cls-1",
    "data-name": "Elipse 7",
    rx: 24.986,
    ry: 24.986
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_340",
    d: "M244.38 0q-.632 0-1.257.031a24.986 24.986 0 0 1 0 49.909q.625.031 1.257.031a24.986 24.986 0 1 0 0-49.971z",
    className: "cls-2",
    "data-name": "Trazado 340",
    transform: "translate(-219.394)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_341",
    d: "M88.787 83.58c-2.84 5.808-10.1 7.359-15.929 7.431-5.833-.072-13.088-1.624-15.929-7.431s-7.156-23.468.148-28.679 24.259-5.21 31.562 0 2.989 22.87.148 28.679z",
    className: "cls-3",
    "data-name": "Trazado 341",
    transform: "translate(-47.873 -46.017)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_342",
    d: "M117.759 108.567c-1.141 2.539-6.895 3.6-12.051 3.67-5.155-.074-10.91-1.131-12.05-3.67s-7.606-24.639-1.849-28.388 22.043-3.749 27.8 0-.709 25.848-1.85 28.388z",
    className: "cls-4",
    "data-name": "Trazado 342",
    transform: "translate(-80.723 -69.816)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_169",
    "data-name": "Grupo 169",
    transform: "translate(13.168 15.903)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_343",
    d: "M131.669 162.937l.5 18.121 2.22.045v-8.29h1.857v-2.084h-1.857V165.2h2.492v-2.265z",
    className: "cls-5",
    "data-name": "Trazado 343",
    transform: "translate(-131.669 -162.937)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_344",
    d: "M201.148 162.937h2.434l-.033 18.166h-2.31z",
    className: "cls-5",
    "data-name": "Trazado 344",
    transform: "translate(-194.367 -162.937)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_345",
    d: "M245.844 163.28h5.214a23.6 23.6 0 0 1 1.752 6.682 87.8 87.8 0 0 1 .255 11.427l-2 .024-.01-8.352-2.833-.024-.027 8.376h-2.165zm5.019 7.778s-.172-4.013-1.285-5.7a12.771 12.771 0 0 0-1.46 0v5.669z",
    className: "cls-5",
    "data-name": "Trazado 345",
    transform: "translate(-234.7 -163.246)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_346",
    d: "M324.737 163.28h6.184v1.9h-1.848l-.32 16.206h-2.385l.324-16.171h-1.984z",
    className: "cls-5",
    "data-name": "Trazado 346",
    transform: "translate(-305.867 -163.246)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiat);
export default __webpack_public_path__ + "static/media/fiat.68bc0d6a88a64b6841f22b55e3a56357.svg";
export { ForwardRef as ReactComponent };